export const getThought = (childCallingName) => {
  // Handle null, undefined, or empty inputs gracefully
  const safeName = childCallingName || "";
  const fl = safeName.length > 0 ? Array.from(safeName)?.[0] || "А" : "А";
  const ccn = safeName || "друже";
  const thoughts = [
    `Правильно «Рибус-метод» чи «Ребус‑метод», ${ccn}? 🐠`,
    `Це 🏠 хатка, яку збудував собі Джек, ${ccn}`,
    `Ґуґлити чи не ґуґлити, ${ccn}?`,
    `Читати чи не читати, ${ccn}?`,
    `Не гальмуй — байдикуй, ${ccn}!`,
    `🇹🇷 Тешекюр едерім, ${ccn}!`,
    `Qırımtatar elifbesi теж класна, ${ccn}!`,
    `Алéкса, Сірі чи «Ок, Ґуґл», ${ccn}?`,
    `ChatGPT чи Клод? ${ccn}?`,
    `Локдаун вже закінчився, ${ccn}?`,
    `Гетьман чи супермен, ${ccn}?`,
    `Фонк чи фанк, ${ccn}?`,
    `Що, ${ccn} вчимося?`,
    `Бабрались в брудній баюрі два бобри брунатно-бурі, ${ccn}! 🦫`,
    `🇬🇧 Вері найс, ${ccn}!`,
    `«Читати — не перечитати» — каже тато`,
    `Людина чи 🤖 ChatGPT, Семе та ${ccn}?`,
    `🇮🇱 Шалом, ${ccn}!`,
    `🇵🇱 Чешч, ${ccn}!`,
    `🇱🇹 Ачу-лабай, ${ccn}!`,
    `Кажуть, я Бешкечитесенко, ${ccn}!`,
    `Бешкечитник — це я, ${ccn}!`,
    `Якщо що, я Бешкечитун, ${ccn}!`,
    `Я твоя Бешкечитуся, ${ccn}!`,
    `Називай мене Бешкечитенко, ${ccn}!`,
    `🇬🇷 Евхарісто полі, Костянтинесе та ${ccn}`,
    `Нехай буде з тобою сила, Люк та ${ccn} 🌌`,
    `Танці-шманці, ${ccn}`,
    `Чука-бука, ${ccn}`,
    `Схожа 🐽 свиня на 🐴 коня, тільки масть не така, ${ccn}!`,
    `👰‍♀️🤵‍♂️ Тілі-тілі-тісто, ${ccn}!`,
    `Іноді я повторююсь, іноді я повторююсь, ${ccn}`,
    `Отака абетка, ${ccn}!`,
    `Що смачніше, мед чи цукерки, ${ccn}?`,
    `Поплакала і стоп. 🙅‍♀️`,
    `${fl}-${fl}-${fl}-${fl}-${fl}-${fl}-${fl}-${fl}, ${ccn}!`,
    `Йшла собака через міст — лапи, лапи, лапи, хвіст, ${ccn}!`,
    `Чемний голос відповів: «То є славне місто Львів», ${ccn}`,
    `Ми переможемо, ${ccn}!`,
    `Як там сусіди зверху, ${ccn}?`,
    `Що там сьогодні на вулиці, ${ccn}?`,
    `Експеліармус 🪄, ${ccn}!`,
    `Люмос 🪄, Гаррі та ${ccn}!`,
    `Сьогодні у мене вихідний, ${ccn}`,
    `Оце так так, ${ccn}?`,
    `А Саша вийде, ${ccn}?`,
    `Вільна каса, ${ccn} та Джері!`,
    `Ахраааана, атмєєєна, Джері та ${ccn}!`,
    `Шукаємо пригод, ${ccn}`,
    `Ой, я лусну, ${ccn}!`,
    `Пустун пустуна бачить із віддаля, ${ccn}!`,
    `Якщо іграшки зібрані, можемо гратися, ${ccn}!`,
    `Граємо в хованки, ${ccn}!`,
    `Зараз пограємось — і я погризу 🍏 яблучко, ${ccn}!`,
    `Сьогодні я кидаюся подушками, ${ccn}!`,
    `Один плюс один — це два, ${ccn}!`,
    `Сьогодні я граюся тваринками, ${ccn}!`,
    `Сьогодні я граюся динозаврами, ${ccn}!`,
    `Сьогодні я граюся ляльками, ${ccn}!`,
    `Єхидна, ґава, їжак ще й шиплячі плазуни бігцем форсують Янцзи, ${ccn}!`,
    `Сьогодні я граюся кубиками, ${ccn}!`,
    `Карабарабука, ${ccn}!`,
    `Де ти з’їси ці лини, ${ccn}?`,
    `Хто не заховався, я не винен, ${ccn}!`,
    `Час пострибати, ${ccn}!`,
    `Покажи, як стрибають зайчики, ${ccn}!`,
    `Покажи, як бігають зайчики, ${ccn}!`,
    `Покажи, як бігають вовчики за зайчиками, ${ccn}!`,
    `Покажи, як стрибають м’ячики, ${ccn}!`,
    `Рухаємося, ${ccn}!`,
    `Рухаймося, ${ccn}!`,
    `А покажеш мені свою зарядку, ${ccn}?`,
    `Де там твої гантелі, ${ccn}?`,
    `Біжи, ${ccn}, біжи!`,
    `Покажи, як ти стрибаєш, ${ccn}!`,
    `А тепер зарядка, ${ccn}!`,
    `А тепер зарядочка, ${ccn}!`,
    `Кубики Рубіка, ${ccn}!`,
    `Час поборюкатися, ${ccn}!`,
    `Ще трохи позаймаємось, і на вулицю, ${ccn}!`,
    `А тепер руханка, ${ccn}!`,
    `Стрибаймо, бо ми того варті, ${ccn}!`,
    `Присіли, встали, присіли, встали, ${ccn}!`,
    `Час побігати по хаті, ${ccn}`,
    `Ніколи не зайве сказати «дякую», ${ccn}`,
    `Ніколи не зайве сказати «будь ласка», ${ccn}`,
    `Ніколи не зайве сказати «спасибі», ${ccn}`,
    `Куця-Пуця на тину сиділа, Куця‑Пуця вниз полетіла, Олексо та ${ccn}!`,
    // (можна зробити ролик під мамба намба файв),
    `${childCallingName}, ${ccn}, ${ccn}!`,
    `А тепер дикі танці, Руслано та ${ccn}!`,
    `Що ти за один, ${ccn}?`,
    `О, аж ось і ти, ${ccn}!`,
    `Ти молодець, ${ccn}!`,
    `Я радію, коли бачу як ти стараєшся, ${ccn}!`,
    `Молодчинка, ${ccn}!`,
    `Супер, ${ccn}!`,
    `Дуже добре, ${ccn}!`,
    `Молодець, моє ти хороше!`,
    `Краще й краще, ${ccn}!`,
    `Жити класно, ${ccn}!`,
    `У тебе добре виходить, ${ccn}!`,
    `Під дубочком — їжачок, на дубочку — павучок, ${ccn}`,
    `Не знаєш, де моя ліва шкарпетка, ${ccn}?`,
    `Сорока-ворона кашку варила, ${ccn}`,
    `Зворотний відлік, продувка, протяжка, Ілоне та ${ccn}! 🚀`,
    `❤️ Люби себе, сонечко!`,
    `Які новини, ${ccn}?`,
    `Трансформуймося, автоботи та ${ccn}!`,
    `Розкажу я вам не казку, а бувальщину одну, ${ccn}!`,
    `Маска — «Ма», ${ccn}!`,
    `Кубик — «Ку», ${ccn}!`,
    `Жуйка — «Жу», ${ccn}!`,
    `Лійка — «Лі», ${ccn}!`,
    `Рибка — «Ри», ${ccn}!`,
    `Тигрик — «Ти», ${ccn}! Тобто, ти, напевно, не тигрик.`,
    `Кубик — «Ку». Кулька — теж «Ку», ${ccn}!`,
    `Тишком-нишком 🐭 мишка вийшла, ${ccn}!`,
    `Та коли стемніє, ми станцюємо в зірках, ${ccn}!`,
    `Же не парль па, ${ccn}. Але дуже 🇫🇷 хочу!`,
    `Іхь шпрехе кайн 🇩🇪 дойч, ${ccn}. Але цікаво навчитися!`,
    `Ай дон’т спік 🇬🇧 інґліш єт, ${ccn}. Але було б класно!`,
    `Компренде, ${ccn}? Я поки що не 🇮🇹 компрендо.`,
    `Добрий вечір тобі, ${ccn}`,
    `Застеляйте столи та все килимами, ${ccn}`,
    `Ти вже все знаєш, ${ccn}`,
    `Я — 🪶 пташка на ім’я Джонатан, ${ccn}`,
    `${childCallingName}, хто ти?`,
    `Сійся, родися, ${ccn}! 🌾`,
    `Так ніхто не кохав, ${ccn}! Через тисячі літ лиш приходить подібне кохання.`,
    `Вчися чекати, ${ccn}, вчися чекати ⏳`,
    `Чому являєшся мені у сні, ${ccn}?`,
    `Садок вишневий коло хати, ${ccn}!`,
    `Коли ми йшли удвох з тобою, вузькою стежкою по полю, ${ccn}!`,
    `Амінь, ${ccn}!`,
    `Щедрик-щедрівочка, прилетіла 🪺 ластівочка, ${ccn}!`,
    `${childCallingName}, у нас проблем нема! 👩🏽‍🚀`,
    `Наші люди всюди, ${ccn}!`,
    `Хай буде так, ${ccn}!`,
    `Там, куди я йду, сонячні дощі, Олю та ${ccn}!`,
    `Відчиняй свої двері для нас, ${ccn}!`,
    `Мої рибки за склом, Альоно та ${ccn}!`,
    `Як би я була не я, ${ccn}!`,
    `Люди, як кораблі, ${ccn}`,
    `Танцюю танець 🐧 пінгвіна, ${ccn}`,
    `Хочеш, я твоїм 🌈 кольором буду, ${ccn}?`,
    `Ось і дітлахи у крутому взутті, ${ccn}!`,
    `Справа в тому, що у мене немає дому, ${ccn}. Але обовʼязково зʼявиться!`,
    `Побачити Париж і жити довго, ${ccn}!`,
    `🇩🇪 Ґутен таґ, ${ccn}!`,
    `Радію тобі, ${ccn}!`,
    `Обійми мене, ${ccn}!`,
    `Вам-пам параба-пам-пам, ${ccn}!`,
    `Лиш вона сидітиме одна, ${ccn}!`,
    `Весна-весна-весна прийде, Олеже та ${ccn}!`,
    `Це моя земля, ${ccn}!`,
    `Це моє місто, ${ccn}!`,
    `Лаша тумбай, Вєро та ${ccn}!`,
    `Нема слів, ${ccn}!`,
    `Ніт, ${ccn}!`,
    `Давай вже після 🎄 свят, ${ccn}!`,
    `Виходжу з Ⓜ️ метро, ${ccn}!`,
    `Сідаю в 🚇 метро, ${ccn}!`,
    `Я в 🚍 маршрутці, ${ccn}!`,
    `Непозбувна бентега, ${ccn}!`,
    `Не зрада, а перемога, ${ccn}!`,
    `Тішуся, дуже тішуся, ${ccn}!`,
    `Агой, кротику і ${ccn}!`,
    `Лови момент, ${ccn}`,
    `Десять 🐘 слоненят, Петрику та ${ccn}`,
    `Там, де ми є, ${ccn}`,
    `Зроби мені хіп-хоп, ${ccn}`,
    `А я люблю кататися на сноуборді, Сашко та ${ccn}`,
    `Жує мене журба, ${ccn}`,
    `Як тебе не любити, Києве мій, ${ccn}?`,
    `А далеко до Києва, ${ccn}?`,
    `А далеко до Харкова, ${ccn}?`,
    `А далеко до Одеси, ${ccn}?`,
    `А далеко до моря, ${ccn}?`,
    `А далеко до 🏔️ гір, ${ccn}?`,
    `Раз, два, три, чотири, п’ять, ${ccn}!`,
    `Мені сьогодні наснилася хмарка, ${ccn}`,
    `Любиш киць чи песиків, ${ccn}?`,
    `Тато любить чай чи каву, ${ccn}?`,
    `Сьогодні піжамна вечірка, ${ccn}!`,
    `Я не здамся без бою, ${ccn}!`,
    `Сонце пече, річка тече, ${ccn}!`,
    `Хто був першим: курка чи яйце, ${ccn}?`,
    `Еники-беники їли вареники, ${ccn}!`,
    `Будемо читати, ${ccn}!`,
    `Як сьогодні, гуляєш на вулиці, ${ccn}?`,
    `Ну що, граємося, ${ccn}?`,
    `Займаємось, ${ccn}`,
    `Вечеря вже з’їдена, ${ccn}?`,
    `Як тебе звати, ${ccn}?`,
    `${childCallingName}, клас!`,
    `Що будемо робити, ${ccn}?`,
    `Ти — метелик, я — джмелятко, ти — маленький, я — малятко, ${ccn}`,
    `Лондон — столиця Великої Британії, ${ccn} 🎡`,
    `Ти можеш бути ким забажаєш, ${ccn}!`,
    `Ені, бені, раба, квінтер, швінтер, жаба, ${ccn}!`,
    `Що тобі сьогодні вдалося особливо добре, ${ccn}?`,
    `Зубки почищені, ${ccn}?`,
    `У Сонячній системі вісім 🪐 планет, ${ccn}! Чи таки сім???`,
    `Поїв, оце, смачний супчик, ${ccn}!`,
    `Квачику, квачику, дай калачику!`,
    `Як ся маєш, ${ccn}?`,
    `Які плани на вечір, ${ccn}?`,
    `Тралі-валі-фестивалі, ${ccn}!`,
    `${childCallingName}, як настрій?`,
    `Помовч хвильку, ${ccn}. Тепер кажи!`,
    `${childCallingName}, слухай: були собі дід і баба, і була у них курочка — ряба. Знесла курочка яєчко. Дід бив-бив, не розбив! Баба била-била, не розбила. Мишка побігла, хвостиком махнула, яєчко покотилось, упало та й розбилось! Дід плаче, баба плаче, а курочка кудкудаче: – не плач, діду, не плач, бабо, я знесу ще вам ще яєчко, та не просте, а 🐣 золоте!`,
  ];
  return thoughts[Math.floor(Math.random() * thoughts.length)];
};
